export default {
  name: 'en',
  data: {
    modal: {
      cancel: 'Cancel',
      confirm: 'OK'
    },
    pagination: {
      prev: 'Prev Page',
      next: 'Next Page'
    },
    select: {
      empty: 'No Data... \\[ o_x ]/'
    },
    table: {
      empty: 'No Data... \\[ o_x ]/'
    }
  }
}